import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

import Spinner from '../../Shared/Spinner';
import { SettingHeader, SettingsContainer, TitleContainer } from '../components/BranchComponents';

import {
  checkCsvInviteFileExistence,
  runMassInvite,
  checkPendingMassInvite,
  getMassInviteStatus,
} from '../../../redux/pharmacy';
import { HealtheraButton } from '../../../healtheraComponents';

const MassInviteCsvDetails = ({ pharmacy }) => {
  const dispatch = useDispatch();

  const {
    csvExists, error, isLoading,
    massInviteStats, pendingMassInviteId, massInvitePendingNumbersCount,
  } = useSelector(state => state.pharmacy);

  const { _id: pharmacyId } = pharmacy;

  useEffect(() => {
    (async () => {
      const result = await dispatch(checkPendingMassInvite(pharmacyId));
      if (!result.payload?.data?.data?.[0]?.mass_invite_id) {
        dispatch(checkCsvInviteFileExistence(pharmacyId));
      }
    })();
  }, [dispatch, pharmacyId]);

  useEffect(() => {
    const pollPendingInvite = async () => {
      if (pharmacyId && pendingMassInviteId) {
        const result = await dispatch(getMassInviteStatus(pharmacyId, pendingMassInviteId));
        if (!result.payload.data?.data?.[0]?.finished) return pollPendingInvite();
      }
    };

    pollPendingInvite();
  }, [dispatch, pharmacyId, pendingMassInviteId])

  const runMassInviteHandler = () => {
    dispatch(runMassInvite(pharmacyId));
  };

  return (
    <SettingsContainer>
      <SettingHeader>
        <TitleContainer>Mass CSV invite</TitleContainer>
      </SettingHeader>
      {!massInviteStats && !pendingMassInviteId && (
        <>
          <HealtheraButton margin="5px 0" onClick={runMassInviteHandler} disabled={!csvExists || isLoading}>
            Run mass invite
          </HealtheraButton>
          {!csvExists && (
            <Hint>
              Pharmacy mass invite CSV doesn't exist. Please upload it via Connect to proceed.
            </Hint>
          )}
          {typeof error === 'string' && (
            <Hint>{error}</Hint>
          )}
        </>
      )}
      {pendingMassInviteId && (
        <Flex>
          <SpinnerContainer>
            <SpinnerText>
              {massInvitePendingNumbersCount === 0
                ? 'Processing invite file...'
                : `Pending invites: ${massInvitePendingNumbersCount}`
              }
            </SpinnerText>
            <Spinner />
          </SpinnerContainer>
        </Flex>
      )}
      {massInviteStats && (
        <div>
          Results:
          <div>
            Failed numbers: {massInviteStats.failed_telephone_numbers}
          </div>
          <div>
            Invalid numbers: {massInviteStats.invalid_telephone_numbers}
          <div>
          </div>
            Successful numbers: {massInviteStats.successful_invites}
          </div>
        </div>
      )}
    </SettingsContainer>
  );
};

const Hint = styled.p`
  margin: 0;
  margin-top: 5px;

  font-size: 14px;
`;

const SpinnerContainer = styled.div`
  position: relative;
  width: max-content;
`;

const SpinnerText = styled.div`
  width: 50%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
`;

export default MassInviteCsvDetails;
